// Redux Action CONSTANTS
import * as actionTypes from "./actionTypes";

// Ajax Methods
import ajaxMethods from "../../api/ajax-methods";

// Ajax End Points
import * as ajaxEndpoints from "../../api/ajax-endpoints";
import { appInsights } from "../../config/appInsights";

export const actionStart = () => {
  return { type: actionTypes.GET_INVESTMENTS_START };
};

export const makeInvestmentSuccess = (payload) => {
  return { type: actionTypes.MAKE_INVESTMENT_SUCCESS, payload };
};

export const actionFailure = (error) => {
  return { type: actionTypes.GET_INVESTMENTS_FAILURE, error };
};

export const getInvestments = () => {
  return function (dispatch) {
    dispatch(actionStart());
    // ajaxMethods.post(`${ajaxEndpoints.INVESTMENTS}\\${id}`)
    ajaxMethods
      .get(ajaxEndpoints.INVESTMENTS)
      .then((response) => {
        if (response) {
          dispatch({
            type: actionTypes.GET_INVESTMENTS_SUCCESS,
            payload: response,
          });
        } else {
          dispatch(actionFailure({ message: "Newtork Failure" }));
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "investments.js",
          },
        });
        dispatch(actionFailure(error));
      });
  };
};

export const makeInvestment = (investmentData) => {
  return function (dispatch) {
    dispatch(actionStart());
    ajaxMethods
      .post(ajaxEndpoints.INVESTMENTS, investmentData)
      .then((response) => {
        dispatch(makeInvestmentSuccess(response));
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "investments.js",
          },
        });
        dispatch(actionFailure(error));
      });
  };
};
